import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncomeAndAssetsSteps } from '../../../../../../enums/income-and-assets-steps.enum';
import { GettingStartedSteps } from '../../../../../../enums/getting-started-steps.enum';
import { StepperContextService } from '../../../../../../services/stepper-context.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { StepperTasksService } from '../../../../../../services/stepper-tasks.service';
import { StepSection } from '../../../../../../enums/step-section.enum';
import { PropertySteps } from '../../../../../../enums/property-steps.enum';
import { MatDivider, MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { SubmitSteps } from '../../../../../../enums/submit-steps.enum';

export enum InvestmentExtraIncomeOptions {
  Yes = 'Yes',
  No = 'No, I plan to only use rental income'
}

@Component({
  selector: 'lgv-investment-extra-income',
  standalone: true,
  imports: [CommonModule,
    MatDividerModule,
    MatButtonModule
  ],
  templateUrl: './investment-extra-income.component.html',
  styleUrls: ['./investment-extra-income.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestmentExtraIncomeComponent {
  InvestmentExtraIncomeOptions = InvestmentExtraIncomeOptions
  isDialog = this.contextService.isDialog
  optionSelected = this.answerService.getAnswer(IncomeAndAssetsSteps.InvestmentExtraIncome) ?? ''
  isPurchase = this.answerService.getAnswer(GettingStartedSteps.LoanPurpose) === 'Purchase' ? true : false

  @Output() stepChange = new EventEmitter<any>();
  @Output() sectionChange = new EventEmitter<any>();

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    public taskService: StepperTasksService,
  ) { }

  onAnswerSelected(ans: string) {
    this.optionSelected = ans
  }

  onNext() {
    this.answerService.setAnswer(IncomeAndAssetsSteps.InvestmentExtraIncome, this.optionSelected)
    this.answerService.getAnswer(IncomeAndAssetsSteps.InvestmentExtraIncome) === InvestmentExtraIncomeOptions.Yes
      ? this.goToStep(IncomeAndAssetsSteps.IncomeSource) : this.goToSection(StepSection.Submit, SubmitSteps.Confirmation);
  }

  onBack() {
    this.answerService.setAnswer(IncomeAndAssetsSteps.InvestmentExtraIncome, this.optionSelected)
    this.goToStep(IncomeAndAssetsSteps.InvestmentRentalIncome)
  }

  goToStep(step) {
    this.stepChange.emit(step);
  }

  goToSection(section, step) {
    this.sectionChange.emit([section, step]);
  }

  isBtnSelected(option: string) {
    if (option === this.optionSelected) {
      return true
    }
  }

  isNextDisabled(): boolean {
    if (this.optionSelected === '') {
      return true
    }
    return false
  }

}
